

//Data imports
import AccessMatrix from '@/router/access-matrix';

//View and component imports
//import Planner from "@/views/landingpages/UnderConstruction.vue";
import Planner from "@/views/planning/PlanningContainer.vue";

//Export item
const trunk = {
  meta: {
    authorize: AccessMatrix.PlannerTrunk.module,
    display: { key: "servicesystem.pages.page_titles.planner" },
    icon: "$planner",
  },
  path: '/planner/:appointmentId?',
  name: 'Planner',
  component: Planner,
};

export default trunk;